module.exports = __webpack_public_path__ + "img/req_shou.94f213db.png";